/**
 * validateDrawerContainer ensures the js-bs-drawer container is
 * present before react initialises the drawer.
 * @return
 */
const validateContainer = () => {
    const drawer = document.getElementById("js-bs-drawer");
    const myBookmakersPage = document.getElementById("js-bs-bookmakersPage");

    if (drawer === null) {
        const drawerContainer = document.createElement("div");
        drawerContainer.setAttribute("id", "js-bs-drawer");
        document.body.appendChild(drawerContainer);
    }

    if (
        myBookmakersPage === null &&
        window.location.pathname.includes("/my-bookmakers")
    ) {
        const footer = document.getElementsByClassName("ui-footer")[0];
        const bookmakersPageContainer = document.createElement("div");
        footer.parentNode.insertBefore(bookmakersPageContainer, footer);
        bookmakersPageContainer.setAttribute("id", "js-bs-bookmakersPage");
    }
};

export default () => {
    validateContainer();
};



// WEBPACK FOOTER //
// /src/js/App/containerValidator.js